import React, { useState } from 'react';
import { Grid, Card, CardMedia, CardContent, Typography, Container, Box, Pagination } from '@mui/material';
import { capitalizeFirstLetter } from '../../../configs/fontConfigs';
import {  titleStyle, categoryContainerStyle, categoryItemStyle, selectedCategoryTitleStyle, cardStyle, cardMediaStyle, cardContentStyle, cardTitleStyle, categoryIconStyle } from '../../../styles/PublicPage/menu';
import colorConfigs from '../../../configs/colorConfigs';
import Menu from '../../../api/MenuAPI';
import { AWS_MENU_URL } from '../../../configs/constants';
import { typo } from '../../../assets/fonts/font';

const DesktopMenu: React.FC<{ machineId: string }> = ({ machineId }) => {
  const { data, selectedCategory, setSelectedCategory } = Menu(machineId);
  const [page, setPage] = useState<number>(1);
  const itemsPerPage = 8;

  const prependImageUrl = (url: string) => {
    return `${AWS_MENU_URL}/${url}`;
};

  const handleCategoryClick = (category: string) => {
    setSelectedCategory(category);
    setPage(1);
  };

  const categoryImages: { [category: string]: string } = {};
  (data || []).forEach(item => {
    if (!categoryImages[item.main_tag_name]) {
      categoryImages[item.main_tag_name] = prependImageUrl(item.featured_image_url);
    }
  });

  const filteredData = data.filter(item => item.main_tag_name === selectedCategory);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const startIndex = (page - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, endIndex);

  return (
    <Container maxWidth="lg">
      <Typography variant="h4" sx={[titleStyle, typo.menuFonts]}>
        Our Menu
      </Typography>
      <Box sx={categoryContainerStyle}>
        <Grid container justifyContent="flex-start" spacing={3}>
          {Array.from(new Set(data.map(item => item.main_tag_name))).map(category => (
            <Grid item key={category} xs={6} sm={3} md={2} sx={{ textAlign: 'center' }}>
              <Box
                onClick={() => handleCategoryClick(category)}
                sx={categoryItemStyle(category === selectedCategory)}
              >
                <img
                  src={categoryImages[category]}
                  alt={category}
                  style={categoryIconStyle}
                />
                <Typography variant="subtitle2" sx={[{ mt: 1, textTransform: 'capitalize' }, typo.menuFonts]}>
                  {capitalizeFirstLetter(category)}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {selectedCategory && (
        <>
          <Typography variant="h5" sx={[{ mt: 1, textTransform: 'capitalize' } , selectedCategoryTitleStyle, typo.menuFonts]}>
            {capitalizeFirstLetter(selectedCategory)}
          </Typography>
          <Grid container spacing={2}>
            {paginatedData.map(item => (
              <Grid item xs={12} sm={6} md={3} key={item.id}>
                <Card sx={cardStyle}>
                  <CardMedia
                    component="img"
                    height="300"
                    image={prependImageUrl(item.featured_image_url)}
                    sx={cardMediaStyle}
                  />
                  <CardContent sx={cardContentStyle}>
                    <Typography gutterBottom sx={[cardTitleStyle, typo.menuFonts]}>
                      {item.name}
                    </Typography>
                    <Typography variant="subtitle1" color="text.primary" sx={typo.menuFonts}>
                      $ {item.price.toFixed(2)}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={(event, value) => setPage(value)}
              sx={{
                '& .MuiPaginationItem-root': {
                  color: `${colorConfigs.greytext} !important`,
                  ...typo.menuFonts,
                },
                '& .Mui-selected': {
                  backgroundColor: `${colorConfigs.primary} !important`,
                  color: `${colorConfigs.secondary} !important`,
                  ...typo.menuFonts,
                },
              }}              
            />
          </Box>
        </>
      )}
    </Container>
  );
};

export default DesktopMenu;